<template>
  <v-menu
    offset-y
    location="bottom left"
    v-if="partnerShops.length > 0"
  >
    <template #activator="{ props:menu }">
      <v-tooltip location="bottom">
        <template #activator="{ props:tooltip }">
          <v-icon
            v-bind="mergeProps(menu, tooltip)"
            class="mr-7 second-menu-item"
            :icon="Icons.CART_OUTLINE"
          />
        </template>
        <span>{{ t("navigation.tooltip.partnerShops") }}</span>
      </v-tooltip>
    </template>
    <v-list>
      <v-list-item
        :href="partnerShop.url"
        target="_blank"
        v-for="partnerShop in partnerShops"
        :key="partnerShop.id"
      >
        <v-list-item-title v-dompurify-html="partnerShop.name" />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
import {partnerShops} from '@/composables/layout/baseLayout';
import {mergeProps} from 'vue';
import {Icons} from '@simpleforyou/client-core';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
</script>

<style scoped>

</style>
